import React, { useState, useEffect } from "react";
import { createRoot } from "react-dom/client";
import { Container } from "@mui/material";
import Breadcrumbs from "../components/Breadcrumbs/Breadcrumbs";
import NoContent from "../components/NoContent/NoContent";
import Common from "../utils/common";
import AmbassadorHelper from "../utils/AmbassadorHelper";
import ConfigurationHelper from "../configuration/ClientConfigurationHelper";
import ThemeProviderWrapper from "../hoc/ThemeProviderWrapper";
import ProductsCollection from "../components/ProductsCollection/ProductsCollection";
import StorefrontHeader from "../components/StorefrontHeader/StorefrontHeader";
import GridContent from "../components/Grid/GridContent";

const AmbassadorPage = () => {
    const [hasContent, setHasContent] = useState(true);
    const [contentId, setContentId] = useState(true);
    const [ambassadorVideos, setAmbassadorVideos] = useState([]);

    useEffect(() => {
        Common.createStorefrontStructureData(
            ConfigurationHelper.getGlobalConfiguration().ambassadorData,
            ambassadorVideos,
        );
    }, [ambassadorVideos]);

    return (
        <ThemeProviderWrapper>
            <Breadcrumbs
                className={"tvp-breadcrumbs-container"}
                keepOnMobile
                breadcrumbsList={[
                    {
                        name: `${AmbassadorHelper.getDisplayName(ConfigurationHelper.getGlobalConfiguration().ambassadorData)}`,
                        url: "#",
                        active: true,
                    },
                ]}
            />

            <StorefrontHeader
                ambassador={ConfigurationHelper.getGlobalConfiguration().ambassadorData}
            />
            <Container>
                <ProductsCollection
                    contentId={contentId}
                    creator_id={ConfigurationHelper.getGlobalConfiguration().ambassadorData.id.toString()}
                />
            </Container>
            {hasContent && (
                <>
                    <Container
                        maxWidth={false}
                        sx={{
                            backgroundColor: "#F8F8F8",
                            paddingY: {
                                sm: "32px",
                                xs: "16px",
                            },
                            paddingX: 0,
                        }}
                    >
                        <GridContent
                            pmEvent={true}
                            gridTitle={" "}
                            redirect={false}
                            creator_id={ConfigurationHelper.getGlobalConfiguration().ambassadorData.id.toString()}
                            resultsCallback={(videos) => {
                                setAmbassadorVideos(videos);
                                setContentId(videos[0].id);
                            }}
                            noResultsCallback={() => {
                                setHasContent(false);
                            }}
                        />
                    </Container>
                </>
            )}

            {!hasContent && (
                <NoContent>
                    I haven&apos;t posted any content yet, please check back soon.
                </NoContent>
            )}
        </ThemeProviderWrapper>
    );
};

export default AmbassadorPage;

const targetEl = document.getElementById("app-container");
if (targetEl) {
    const root = createRoot(targetEl);
    root.render(<AmbassadorPage />);
}
